import View from './SkipLinksNavigation'
import { connect } from 'react-redux'
import { compose } from 'ramda'
import { signOut } from '../../../../store/modules/session'

const mapStateToProps = state => ({
  locale: state.router.locale,
  user: state.session.user,
})

const mapDispatchToProps = dispatch => ({
  onSignOut: compose(dispatch, signOut),
})

const SkipLinksNavigation = connect(mapStateToProps, mapDispatchToProps)(View)

export default SkipLinksNavigation
